/** Generate by swagger-axios-codegen */
// @ts-nocheck
/* eslint-disable */

/** Generate by swagger-axios-codegen */
/* eslint-disable */
// @ts-nocheck
import axiosStatic, { AxiosInstance, AxiosRequestConfig } from 'axios';

export interface IRequestOptions extends AxiosRequestConfig {}

export interface IRequestConfig {
  method?: any;
  headers?: any;
  url?: any;
  data?: any;
  params?: any;
}

// Add options interface
export interface ServiceOptions {
  axios?: AxiosInstance;
}

// Add default options
export const serviceOptions: ServiceOptions = {};

// Instance selector
export function axios(configs: IRequestConfig, resolve: (p: any) => void, reject: (p: any) => void): Promise<any> {
  if (serviceOptions.axios) {
    return serviceOptions.axios
      .request(configs)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  } else {
    throw new Error('please inject yourself instance like axios  ');
  }
}

export function getConfigs(method: string, contentType: string, url: string, options: any): IRequestConfig {
  const configs: IRequestConfig = { ...options, method, url };
  configs.headers = {
    ...options.headers,
    'Content-Type': contentType
  };
  return configs;
}

export const basePath = '';

export interface IList<T> extends Array<T> {}
export interface List<T> extends Array<T> {}
export interface IDictionary<TValue> {
  [key: string]: TValue;
}
export interface Dictionary<TValue> extends IDictionary<TValue> {}

export interface IListResult<T> {
  items?: T[];
}

export class ListResultDto<T> implements IListResult<T> {
  items?: T[];
}

export interface IPagedResult<T> extends IListResult<T> {
  totalCount?: number;
  items?: T[];
}

export class PagedResultDto<T = any> implements IPagedResult<T> {
  totalCount?: number;
  items?: T[];
}

// customer definition
// empty

export class AgentAccountService {
  /**
   * Agent user log-in by username and password
   */
  static login(
    params: {
      /** requestBody */
      body?: LoginModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<LoginResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/auth/login';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Agent user refresh token
   */
  static refreshToken(
    params: {
      /** requestBody */
      body?: RefreshTokenRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RefreshTokenResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/auth/refresh-token';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class AgentBookingService {
  /**
   * Get booking listing with paging
   */
  static getBookings(
    params: {
      /** requestBody */
      body?: BookingPagingRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BookingPagingResponseBasePagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/bookings/get-bookings';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get error booking listing with paging
   */
  static getTodoList(
    params: {
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BookingPagingResponseBasePagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/bookings/get-todo-list';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get booking history listing with paging
   */
  static getBookingHistories(
    params: {
      /** limit number of records */
      limit: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BookingHistoryModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/bookings/get-booking-histories/{limit}';
      url = url.replace('{limit}', params['limit'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get get booking detail with ID
   */
  static getBooking(
    params: {
      /** booking primary key ID */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentBookingModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/bookings/get-booking/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   * Agent update agent booking ref
   */
  static updateAgentBookingRef(
    params: {
      /** requestBody */
      body?: UpdateAgentBookingRefModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/bookings/update-agent-booking-ref';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get cancel booking summary
   */
  static getCancelBookingSummary(
    params: {
      /** booking primary key ID */
      bookingId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CancelBookingSummaryModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/bookings/get-cancel-booking-summary/{bookingId}';
      url = url.replace('{bookingId}', params['bookingId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   * Cancel a booking
   */
  static cancelBooking(
    params: {
      /** requestBody */
      body?: CancelBookingRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CancelBookingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/bookings/cancel-booking';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Export booking report to csv
   */
  static exportBookingReport(
    params: {
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
      /**  */
      refNumber?: string;
      /**  */
      supplierRefNumber?: string;
      /**  */
      orderId?: string;
      /**  */
      bookingStatus?: BookingStatus[];
      /**  */
      paymentStatus?: PaymentStatus[];
      /**  */
      hotelName?: string;
      /**  */
      bookingFrom?: string;
      /**  */
      bookingTo?: string;
      /**  */
      cancellationFrom?: string;
      /**  */
      cancellationTo?: string;
      /**  */
      checkinFrom?: string;
      /**  */
      checkinTo?: string;
      /**  */
      checkoutFrom?: string;
      /**  */
      checkoutTo?: string;
      /**  */
      leadPassenger?: string;
      /**  */
      agentBookingRef?: string;
      /**  */
      isOnHold?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/bookings/export-booking-report';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = {
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc'],
        RefNumber: params['refNumber'],
        SupplierRefNumber: params['supplierRefNumber'],
        OrderId: params['orderId'],
        BookingStatus: params['bookingStatus'],
        PaymentStatus: params['paymentStatus'],
        HotelName: params['hotelName'],
        BookingFrom: params['bookingFrom'],
        BookingTo: params['bookingTo'],
        CancellationFrom: params['cancellationFrom'],
        CancellationTo: params['cancellationTo'],
        CheckinFrom: params['checkinFrom'],
        CheckinTo: params['checkinTo'],
        CheckoutFrom: params['checkoutFrom'],
        CheckoutTo: params['checkoutTo'],
        LeadPassenger: params['leadPassenger'],
        AgentBookingRef: params['agentBookingRef'],
        IsOnHold: params['isOnHold']
      };

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * download booking pdf file
   */
  static downloadBookingPdf(
    params: {
      /** Booking primary key ID */
      bookingId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/bookings/download-booking-pdf/{bookingId}';
      url = url.replace('{bookingId}', params['bookingId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * download order receipt pdf file
   */
  static downloadOrderReceiptPdf(
    params: {
      /** Order ID */
      orderId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/bookings/download-order-receipt-pdf/{orderId}';
      url = url.replace('{orderId}', params['orderId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class AgentBookingReportService {
  /**
   * Get sale by agent report
   */
  static getSaleReport(
    params: {
      /**  */
      limit: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SaleByUserReportModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/reports/get-sale-report/{limit}';
      url = url.replace('{limit}', params['limit'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get booking rate by agent user report
   */
  static getBookingRateReport(
    params: {
      /**  */
      limit: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BookingSuccessRateReportItem[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/reports/get-booking-rate-report/{limit}';
      url = url.replace('{limit}', params['limit'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get booking summary report
   */
  static getBookingSummaryOfTheYear(
    params: {
      /**  */
      limit: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BookingSummaryOfTheYearReportItem[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/reports/get-booking-summary-of-the-year/{limit}';
      url = url.replace('{limit}', params['limit'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get booking summary
   */
  static getBookingSummaryReport(options: IRequestOptions = {}): Promise<BookingSummaryReportModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/reports/get-booking-summary-report';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class AgentOrderBookingService {
  /**
   * Get order listing
   */
  static getOrders(
    params: {
      /** requestBody */
      body?: AgentOrderPagingRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentOrderPagingResponseBasePagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/orders/get-orders';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get order details
   */
  static getOrderDetails(
    params: {
      /** booking order ID */
      orderId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentOrderDetailModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/orders/get-order-details/{orderId}';
      url = url.replace('{orderId}', params['orderId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   * get cancel order bookings summary
   */
  static getCancelOrderBookingsSummary(
    params: {
      /**  */
      orderId?: string;
      /**  */
      bookingIds?: any | null[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CancelOrderBookingsSummaryModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/orders/get-cancel-order-bookings-summary';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { OrderId: params['orderId'], BookingIds: params['bookingIds'] };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   * Cancel multiple bookings in an order
   */
  static cancelOrderBookings(
    params: {
      /** requestBody */
      body?: CancelOrderBookingRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BaseResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/orders/cancel-order-bookings';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class AgentProfileService {
  /**
   * Get Agent detail for current user
   */
  static getDetails(options: IRequestOptions = {}): Promise<AgentDetailModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/agent-profile/get-details';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   * Agent user admin update agent profile
   */
  static update(
    params: {
      /** requestBody */
      body?: AgentUpdateProfileModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/agent-profile/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Upload Agent License
   */
  static uploadLicense(
    params: {
      /**  */
      formFile: any;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FileUploadResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/agent-profile/upload-license';

      const configs: IRequestConfig = getConfigs('post', 'multipart/form-data', url, options);

      let data = null;
      data = new FormData();
      if (params['formFile']) {
        if (Object.prototype.toString.call(params['formFile']) === '[object Array]') {
          for (const item of params['formFile']) {
            data.append('FormFile', item as any);
          }
        } else {
          data.append('FormFile', params['formFile'] as any);
        }
      }

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Download license file
   */
  static downloadLicense(
    params: {
      /** ID of the file */
      fileId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/agent-profile/download-license/{fileId}';
      url = url.replace('{fileId}', params['fileId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   * Add new Credit Card member for agent
   */
  static addNewCreditCardMember(
    params: {
      /** requestBody */
      body?: CreateAgentCreditCardMemberRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/agent-profile/add-new-credit-card-member';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static generateNewCreditCardMember(
    params: {
      /**  */
      token: string;
      /**  */
      memberId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BaseResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/agent-profile/generate-new-credit-card-member/{token}/{memberId}';
      url = url.replace('{token}', params['token'] + '');
      url = url.replace('{memberId}', params['memberId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Update Credit Card member for agent
   */
  static updateCreditCardMember(
    params: {
      /** requestBody */
      body?: UpdateAgentCreditCardMemberRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/agent-profile/update-credit-card-member';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get list of agent credit card members
   */
  static getAgentCreditCardMembers(options: IRequestOptions = {}): Promise<AgentCreditCardMemberModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/agent-profile/get-agent-credit-card-members';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class AgentRegistrationService {
  /**
   * Register a new agent
   */
  static create(
    params: {
      /** requestBody */
      body?: RegisterAgentModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/agent-registration/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Upload Agent License
   */
  static uploadLicense(
    params: {
      /**  */
      formFile: any;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FileUploadResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/agent-registration/upload-license';

      const configs: IRequestConfig = getConfigs('post', 'multipart/form-data', url, options);

      let data = null;
      data = new FormData();
      if (params['formFile']) {
        if (Object.prototype.toString.call(params['formFile']) === '[object Array]') {
          for (const item of params['formFile']) {
            data.append('FormFile', item as any);
          }
        } else {
          data.append('FormFile', params['formFile'] as any);
        }
      }

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class AgentUserService {
  /**
   * Get Agent User listing with paging
   */
  static getAgentUsers(
    params: {
      /** requestBody */
      body?: AgentUserPagingRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentUserPagingResponseBasePagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/agent-users/get-agent-users';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Create agent user
   */
  static createUser(
    params: {
      /** requestBody */
      body?: CreateAgentUserModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/agent-users/create-user';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Update agent user
   */
  static updateUser(
    params: {
      /** requestBody */
      body?: UpdateAgentUserModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/agent-users/update-user';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get current logged in user's information
   */
  static currentUser(options: IRequestOptions = {}): Promise<CurrentUserModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/agent-users/current-user';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   * Agent user forgot password
   */
  static forgotPassword(
    params: {
      /** requestBody */
      body?: AgentForgotPasswordRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BaseResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/agent-users/forgot-password';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Agent user set a new password
   */
  static resetPassword(
    params: {
      /** requestBody */
      body?: ForgotPasswordModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BaseResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/agent-users/reset-password';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Check forgot password token for agent user
   */
  static checkResetPasswordToken(
    params: {
      /** Forgot password token */
      token: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<boolean> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/agent-users/check-reset-password-token/{token}';
      url = url.replace('{token}', params['token'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get Agent User Profile for update
   */
  static getUserProfile(options: IRequestOptions = {}): Promise<UpdateAgentUserProfileModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/agent-users/get-user-profile';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   * Agent user update profile
   */
  static updateProfile(
    params: {
      /** requestBody */
      body?: UpdateAgentUserProfileModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/agent-users/update-profile';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * System user change their own password
   */
  static changePassword(
    params: {
      /** requestBody */
      body?: AgentUserChangePasswordModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BaseResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/agent-users/change-password';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Log off
   */
  static logoff(options: IRequestOptions = {}): Promise<BaseResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/agent-users/logoff';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class AllowCacheService {
  /**
   * Download landing slider image file
   */
  static downloadLandingSliderImage(
    params: {
      /** ID of the file */
      fileId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/booking/allow-cache/download-landing-slider-image/{fileId}';
      url = url.replace('{fileId}', params['fileId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   * Download campaign photo
   */
  static downloadCampaignImage(
    params: {
      /** campaign Id */
      campaignId: string;
      /** ID of the file */
      fileId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/booking/allow-cache/download-campaign-image/{campaignId}/{fileId}';
      url = url.replace('{campaignId}', params['campaignId'] + '');
      url = url.replace('{fileId}', params['fileId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class BookingService {
  /**
   * Start search new hotel available request or get hotel query and hotel available status from existing search session
   */
  static searchHotels(
    params: {
      /** requestBody */
      body?: HotelSearchRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<HotelSearchResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/booking/hotel/search-hotels';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get available hotels with paging and filter parameters
   */
  static getHotels(
    params: {
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
      /**  */
      sessionId: string;
      /**  */
      hotelName?: string;
      /**  */
      hotelTypes?: any | null[];
      /**  */
      allSuppliers: boolean;
      /**  */
      areaCode?: string;
      /**  */
      cityCodes?: any | null[];
      /**  */
      train5Minutes?: boolean;
      /**  */
      train10Minutes?: boolean;
      /**  */
      starRating?: any | null[];
      /**  */
      boardTypes?: any | null[];
      /**  */
      roomTypes?: any | null[];
      /**  */
      facilities?: any | null[];
      /**  */
      priceFrom?: number;
      /**  */
      priceTo?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AvailableHotelPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/booking/hotel/get-hotels';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc'],
        SessionId: params['sessionId'],
        HotelName: params['hotelName'],
        HotelTypes: params['hotelTypes'],
        AllSuppliers: params['allSuppliers'],
        AreaCode: params['areaCode'],
        CityCodes: params['cityCodes'],
        Train5Minutes: params['train5Minutes'],
        Train10Minutes: params['train10Minutes'],
        StarRating: params['starRating'],
        BoardTypes: params['boardTypes'],
        RoomTypes: params['roomTypes'],
        Facilities: params['facilities'],
        PriceFrom: params['priceFrom'],
        PriceTo: params['priceTo']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get available hotels with paging and filter parameters
   */
  static searchHotelRooms(
    params: {
      /** requestBody */
      body?: SearchHotelRoomsRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<HotelRoomResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/booking/hotel/search-hotel-rooms';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get hotel detail by hotel code
   */
  static getHotelDetail(
    params: {
      /**  */
      hotelCode: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<HotelInfoModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/booking/hotel/get-hotel-detail/{hotelCode}';
      url = url.replace('{hotelCode}', params['hotelCode'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get dynamic hotel filters
   */
  static getHotelFilters(
    params: {
      /**  */
      sessionId: string;
      /**  */
      hotelName?: string;
      /**  */
      hotelTypes?: any | null[];
      /**  */
      allSuppliers: boolean;
      /**  */
      areaCode?: string;
      /**  */
      cityCodes?: any | null[];
      /**  */
      train5Minutes?: boolean;
      /**  */
      train10Minutes?: boolean;
      /**  */
      starRating?: any | null[];
      /**  */
      boardTypes?: any | null[];
      /**  */
      roomTypes?: any | null[];
      /**  */
      facilities?: any | null[];
      /**  */
      priceFrom?: number;
      /**  */
      priceTo?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<HotelFilter> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/booking/hotel/get-hotel-filters';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        SessionId: params['sessionId'],
        HotelName: params['hotelName'],
        HotelTypes: params['hotelTypes'],
        AllSuppliers: params['allSuppliers'],
        AreaCode: params['areaCode'],
        CityCodes: params['cityCodes'],
        Train5Minutes: params['train5Minutes'],
        Train10Minutes: params['train10Minutes'],
        StarRating: params['starRating'],
        BoardTypes: params['boardTypes'],
        RoomTypes: params['roomTypes'],
        Facilities: params['facilities'],
        PriceFrom: params['priceFrom'],
        PriceTo: params['priceTo']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get available hotel status for all suppliers
   */
  static getAllSuppliersAvailableHotelStatus(
    params: {
      /** ID of the search session */
      sessionId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<boolean> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/booking/hotel/get-all-suppliers-available-hotel-status/{sessionId}';
      url = url.replace('{sessionId}', params['sessionId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get available hotel autocompletion
   */
  static availableHotelAutocompletion(
    params: {
      /**  */
      sessionId?: string;
      /**  */
      limit?: number;
      /**  */
      allSupplier?: boolean;
      /**  */
      query?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AvailableHotelAutocompletionModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/booking/hotel/available-hotel-autocompletion';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        SessionId: params['sessionId'],
        Limit: params['limit'],
        AllSupplier: params['allSupplier'],
        Query: params['query']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   * Pre-book hotel rooms
   */
  static prebookHotel(
    params: {
      /** requestBody */
      body?: PreBookHotelRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PreBookHotelResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/booking/hotel/prebook-hotel';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get hotel pre-book information
   */
  static getPrebookConfirmationInfo(
    params: {
      /** Pre-book session id */
      sessionId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PrebookHotelConfirmationModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/booking/hotel/get-prebook-confirmation-info/{sessionId}';
      url = url.replace('{sessionId}', params['sessionId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get pre-book hotel summary
   */
  static getPrebookHotelSummary(
    params: {
      /** Pre-book session id */
      sessionId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PrebookHotelSummaryModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/booking/hotel/get-prebook-hotel-summary/{sessionId}';
      url = url.replace('{sessionId}', params['sessionId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   * Set pre book passenger information
   */
  static setPrebookPaxInfo(
    params: {
      /** requestBody */
      body?: SetPreBookPaxInfoRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SetPrebookPaxInfoResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/booking/hotel/set-prebook-pax-info';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Country Autocompletion
   */
  static countryAutocompletion(
    params: {
      /**  */
      limit?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
      /**  */
      query?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CountryAutocompletionModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/booking/hotel/country-autocompletion';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Limit: params['limit'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc'],
        Query: params['query']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   * booking on-hold
   */
  static holdBooking(
    params: {
      /** prebook session ID */
      sessionId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OnHoldBookingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/booking/hotel/hold-booking/{sessionId}';
      url = url.replace('{sessionId}', params['sessionId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get on hold payment options
   */
  static getOnHoldPaymentOptions(
    params: {
      /** booking primary key Id */
      bookingId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PaymentOptionModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/booking/hotel/get-on-hold-payment-options/{bookingId}';
      url = url.replace('{bookingId}', params['bookingId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   * complete on hold booking
   */
  static completeOnHoldBooking(
    params: {
      /** requestBody */
      body?: CompleteOnHoldBookingRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CompleteOnHoldBookingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/booking/hotel/complete-on-hold-booking';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * complete instant booking
   */
  static completeBooking(
    params: {
      /** requestBody */
      body?: CompleteBookingRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CompleteBookingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/booking/hotel/complete-booking';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * confirm continue partial booking
   */
  static continuePartialBooking(
    params: {
      /** booking primary key ID */
      bookingId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ConfirmPartialBookingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/booking/hotel/continue-partial-booking/{bookingId}';
      url = url.replace('{bookingId}', params['bookingId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Cancel partial booking
   */
  static cancelPartialBooking(
    params: {
      /** requestBody */
      body?: ConfirmCancelPartialBookingRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CancelPartialBookingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/booking/hotel/cancel-partial-booking';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get data for confirm partial booking popup
   */
  static getPartialBookingDetail(
    params: {
      /** booking primary key ID */
      bookingId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ConfirmPartialBookingDetailModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/booking/hotel/get-partial-booking-detail/{bookingId}';
      url = url.replace('{bookingId}', params['bookingId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get booking detail for thanks/fail page
   */
  static getBookingDetails(
    params: {
      /** Booking Id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentBookingModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/booking/hotel/get-booking-details/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get list of agent credit card members
   */
  static getAgentCreditCardMembers(options: IRequestOptions = {}): Promise<AgentCreditCardMemberModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/booking/hotel/get-agent-credit-card-members';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class CampaignService {
  /**
   * Get campaign details by slug
   */
  static getDetails(
    params: {
      /** campaign slug */
      slug?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentCampaignDetailsModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/booking/campaigns/get-details';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { slug: params['slug'] };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get campaign hotel info
   */
  static getCampaignHotels(
    params: {
      /** campaign slug */
      slug?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentCampaignHotelModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/booking/campaigns/get-campaign-hotels';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { slug: params['slug'] };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class CommonService {
  /**
   * Get country listing with paging
   */
  static getCountries(
    params: {
      /**  */
      code?: string;
      /**  */
      shortCode?: string;
      /**  */
      name?: string;
      /** Europe = 1, Africa = 2, Asia = 3, Oceania = 4, MiddleEast = 5, NorthAmerica = 6, SouthAmerica = 7 */
      continent?: Continent;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CountryModelBasePagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/common/get-countries';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Code: params['code'],
        ShortCode: params['shortCode'],
        Name: params['name'],
        Continent: params['continent'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class HotelBookmarkService {
  /**
   * Add hotel bookmark by agent user
   */
  static add(
    params: {
      /** Omega hotel code */
      hotelCode: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/booking/hotel-bookmarks/add/{hotelCode}';
      url = url.replace('{hotelCode}', params['hotelCode'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Remove hotel bookmark by agent user
   */
  static remove(
    params: {
      /** Omega hotel code */
      hotelCode: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/booking/hotel-bookmarks/remove/{hotelCode}';
      url = url.replace('{hotelCode}', params['hotelCode'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get hotel book mark list by agent user
   */
  static getHotelBookmarks(
    params: {
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<HotelBookmarkModelBasePagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/booking/hotel-bookmarks/get-hotel-bookmarks';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get bookmark hotel codes by agent users
   */
  static getHotelBookmarkCodes(options: IRequestOptions = {}): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/booking/hotel-bookmarks/get-hotel-bookmark-codes';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class HotelDestinationService {
  /**
   *
   */
  static getDestination(
    params: {
      /**  */
      code: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DestinationModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/booking/destinations/get-destination/{code}';
      url = url.replace('{code}', params['code'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class LandingService {
  /**
   * Get landing slider images
   */
  static getSliderImages(options: IRequestOptions = {}): Promise<LandingSliderImageModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/booking/landing/get-slider-images';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get hotel destinations
   */
  static searchDestinations(
    params: {
      /**  */
      limit?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
      /**  */
      query?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<LandingDestinationModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/booking/landing/search-destinations';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Limit: params['limit'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc'],
        Query: params['query']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get popular hotels
   */
  static getPopularHotels(options: IRequestOptions = {}): Promise<PopularHotelModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/booking/landing/get-popular-hotels';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get popular hotels
   */
  static getPickOfWeekHotels(options: IRequestOptions = {}): Promise<PopularHotelModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/booking/landing/get-pick-of-week-hotels';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class MiyabiAuthService {
  /**
   * Generate auth token
   */
  static generateAuthToken(options: IRequestOptions = {}): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/miyabi/generate-auth-token';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get agent info by auth token
   */
  static getAgentInfo(
    params: {
      /** Miyabi agent auth token */
      token?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent-portal/miyabi/get-agent-info';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { token: params['token'] };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export interface AgentBookingContactDetailModel {
  /**  */
  id?: string;

  /**  */
  bookingId?: string;

  /**  */
  firstName?: string;

  /**  */
  lastName?: string;

  /**  */
  email?: string;

  /**  */
  phoneCode?: string;

  /**  */
  phoneNumber?: string;
}

export interface AgentBookingHotelModel {
  /**  */
  id?: string;

  /**  */
  bookingId?: string;

  /**  */
  hotelCode?: string;

  /**  */
  hotelName?: string;

  /**  */
  hotelNameJp?: string;

  /**  */
  access?: string;

  /**  */
  postalCode?: string;

  /**  */
  address?: string;

  /**  */
  description?: string;

  /**  */
  starRating?: number;

  /**  */
  reviewRating?: number;

  /**  */
  tel?: string;

  /**  */
  fax?: string;

  /**  */
  checkinTime?: string;

  /**  */
  checkoutTime?: string;

  /**  */
  images?: string[];

  /**  */
  rooms?: AgentBookingHotelRoomModel[];
}

export interface AgentBookingHotelRoomModel {
  /**  */
  id?: string;

  /**  */
  bookingHotelId?: string;

  /**  */
  supplierRefNumber?: string;

  /**  */
  noOfAdult?: number;

  /**  */
  noOfChild?: number;

  /**  */
  supplierHotelCode?: string;

  /**  */
  roomTypeCode?: string;

  /**  */
  roomTypeName?: string;

  /**  */
  roomTypeCategory?: string;

  /**  */
  supplier?: string;

  /**  */
  planCode?: string;

  /**  */
  planName?: string;

  /**  */
  planTitle?: string;

  /**  */
  planDesc?: string;

  /**  */
  boardTypeCode?: string;

  /**  */
  boardTypeName?: string;

  /**  */
  checkinTime?: string;

  /**  */
  checkoutTime?: string;

  /**  */
  price?: number;

  /**  */
  priceChanged?: number;

  /**  */
  cancellationPolicies?: RoomCancellationPolicy[];

  /**  */
  images?: string[];

  /**  */
  paymentNotes?: string;

  /**  */
  remarks?: string;

  /**  */
  cancellationNotes?: string;

  /**  */
  nonRefundable?: boolean;

  /**  */
  includedTaxes?: boolean;

  /**  */
  includedFees?: boolean;

  /**  */
  noOfRooms?: number;

  /**  */
  status?: HotelRoomStatus;

  /**  */
  cancelledAt?: Date;

  /**  */
  cancellationFee?: number;
}

export interface AgentBookingLeadPaxModel {
  /**  */
  id?: string;

  /**  */
  bookingId?: string;

  /**  */
  firstName?: string;

  /**  */
  lastName?: string;

  /**  */
  fullName?: string;

  /**  */
  email?: string;

  /**  */
  countryCode?: string;

  /**  */
  countryName?: string;

  /**  */
  phoneCode?: string;

  /**  */
  phoneNumber?: string;
}

export interface AgentBookingModel {
  /**  */
  id?: string;

  /**  */
  orderId?: string;

  /**  */
  refNumber?: string;

  /**  */
  noOfAdult?: number;

  /**  */
  noOfChild?: number;

  /**  */
  agentBookingRef?: string;

  /**  */
  agentCode?: string;

  /**  */
  agentName?: string;

  /**  */
  agentUserUserName?: string;

  /**  */
  locationCode?: string;

  /**  */
  locationName?: string;

  /**  */
  locationType?: LocationType;

  /**  */
  checkinDate?: Date;

  /**  */
  checkoutDate?: Date;

  /**  */
  sellingPrice?: number;

  /**  */
  paymentDue?: number;

  /**  */
  currency?: string;

  /**  */
  bookingStatus?: BookingStatus;

  /**  */
  paymentStatus?: PaymentStatus;

  /**  */
  paymentMethod?: string;

  /**  */
  onHold?: boolean;

  /**  */
  onHoldPaymentDeadline?: Date;

  /**  */
  userAgent?: string;

  /**  */
  userIpAddress?: string;

  /**  */
  createdAt?: Date;

  /**  */
  bookingContactDetail?: AgentBookingContactDetailModel;

  /**  */
  bookingLeadPaxDetail?: AgentBookingLeadPaxModel;

  /**  */
  hotel?: AgentBookingHotelModel;

  /**  */
  roomSearchInfos?: RoomSearchInfo[];
}

export interface AgentCampaignDetailsModel {
  /**  */
  id?: string;

  /**  */
  caption?: string;

  /**  */
  headline?: string;

  /**  */
  headlinePhotoId?: string;

  /**  */
  slug?: string;

  /**  */
  dateFrom?: Date;

  /**  */
  dateTo?: Date;

  /**  */
  freeText?: string;

  /**  */
  desc1?: string;

  /**  */
  desc2?: string;

  /**  */
  topPhotoId?: string;

  /**  */
  subPhotosIds?: string[];

  /**  */
  boardType?: BoardType;

  /**  */
  noOfNights?: number;

  /**  */
  ratePlanCodes?: string[];
}

export interface AgentCampaignHotelModel {
  /**  */
  hotelCode?: string;

  /**  */
  ratePlanCodes?: string;

  /**  */
  omegaHotelCode?: string;

  /**  */
  hotelName?: string;

  /**  */
  originalName?: string;

  /**  */
  address?: string;

  /**  */
  cheapestPrice?: number;

  /**  */
  hotelImages?: string[];

  /**  */
  starRating?: number;
}

export interface AgentCreditCardMemberModel {
  /**  */
  id?: string;

  /**  */
  memberId?: string;

  /**  */
  cardNo?: string;
}

export interface AgentDetailModel {
  /**  */
  id?: string;

  /**  */
  companyName?: string;

  /**  */
  agentType?: AgentType;

  /**  */
  iataId?: string;

  /**  */
  countryCode?: string;

  /**  */
  phoneCode?: string;

  /**  */
  countryName?: string;

  /**  */
  cityName?: string;

  /**  */
  companyPhoneNumber?: string;

  /**  */
  companyAddress?: string;

  /**  */
  companyPostalCode?: string;

  /**  */
  companyEmailAddress?: string;

  /**  */
  companySize?: AgentCompanySize;

  /**  */
  companyWebsite?: string;

  /**  */
  picFirstName?: string;

  /**  */
  picLastName?: string;

  /**  */
  picEmail?: string;

  /**  */
  ecFirstName?: string;

  /**  */
  ecLastName?: string;

  /**  */
  ecPhoneNumber?: string;

  /**  */
  ecEmail?: string;

  /**  */
  accountantFirstName?: string;

  /**  */
  accountantLastName?: string;

  /**  */
  accountantPhoneNumber?: string;

  /**  */
  accountantEmail?: string;

  /**  */
  licenseFileIds?: string[];

  /**  */
  licenseFiles?: AgentLicenseModel[];

  /**  */
  status?: AgentStatus;

  /**  */
  code?: string;

  /**  */
  paymentOptions?: string[];

  /**  */
  creditCardMemberIds?: string[];

  /**  */
  onHoldAllowance?: boolean;
}

export interface AgentForgotPasswordRequest {
  /**  */
  userName?: string;

  /**  */
  emailAddress?: string;
}

export interface AgentLicenseModel {
  /**  */
  licenseFileId?: string;

  /**  */
  licenseFileUrl?: string;

  /**  */
  licenseFileName?: string;
}

export interface AgentOrderDetailModel {
  /**  */
  success?: boolean;

  /**  */
  message?: string;

  /**  */
  roomSearchInfos?: RoomSearchInfo[];

  /**  */
  bookings?: OrderBookingDetailModel[];

  /**  */
  orderId?: string;
}

export interface AgentOrderPagingRequest {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  orderBy?: string;

  /**  */
  orderByAsc?: boolean;

  /**  */
  refNumber?: string;

  /**  */
  orderId?: string;

  /**  */
  bookingStatus?: BookingStatus[];

  /**  */
  paymentStatus?: PaymentStatus[];

  /**  */
  hotelName?: string;

  /**  */
  bookingFrom?: Date;

  /**  */
  bookingTo?: Date;

  /**  */
  cancellationFrom?: Date;

  /**  */
  cancellationTo?: Date;

  /**  */
  checkinFrom?: Date;

  /**  */
  checkinTo?: Date;

  /**  */
  leadPassengerName?: string;

  /**  */
  agentBookingRef?: string;

  /**  */
  supplierRefNumber?: string;
}

export interface AgentOrderPagingResponse {
  /**  */
  orderId?: string;

  /**  */
  orderDate?: Date;

  /**  */
  orderStatus?: OrderStatus;

  /**  */
  checkinDate?: Date;

  /**  */
  checkoutDate?: Date;

  /**  */
  sellingPrice?: number;

  /**  */
  leadPassengerName?: string;

  /**  */
  hotelName?: string;

  /**  */
  supplierRefNumbers?: string[];
}

export interface AgentOrderPagingResponseBasePagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: AgentOrderPagingResponse[];
}

export interface AgentUpdateProfileModel {
  /**  */
  companyName: string;

  /**  */
  iataId?: string;

  /**  */
  countryCode: string;

  /**  */
  cityName: string;

  /**  */
  companyPhoneNumber: string;

  /**  */
  companyAddress: string;

  /**  */
  companyPostalCode: string;

  /**  */
  companyEmailAddress: string;

  /**  */
  companySize?: AgentCompanySize;

  /**  */
  companyWebsite: string;

  /**  */
  picFirstName: string;

  /**  */
  picLastName: string;

  /**  */
  picEmail: string;

  /**  */
  ecFirstName?: string;

  /**  */
  ecLastName?: string;

  /**  */
  ecPhoneNumber?: string;

  /**  */
  ecEmail?: string;

  /**  */
  accountantFirstName?: string;

  /**  */
  accountantLastName?: string;

  /**  */
  accountantPhoneNumber?: string;

  /**  */
  accountantEmail?: string;

  /**  */
  licenseFileIds?: string[];
}

export interface AgentUserChangePasswordModel {
  /**  */
  oldPassword: string;

  /**  */
  password: string;
}

export interface AgentUserPagingRequest {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  orderBy?: string;

  /**  */
  orderByAsc?: boolean;

  /**  */
  agentId?: string;

  /**  */
  firstName?: string;

  /**  */
  lastName?: string;

  /**  */
  userName?: string;

  /**  */
  email?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  role?: string;
}

export interface AgentUserPagingResponse {
  /**  */
  id?: string;

  /**  */
  firstName?: string;

  /**  */
  lastName?: string;

  /**  */
  userName?: string;

  /**  */
  normalizedUserName?: string;

  /**  */
  email?: string;

  /**  */
  normalizedEmail?: string;

  /**  */
  emailConfirmed?: boolean;

  /**  */
  phoneCode?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  phoneNumberConfirmed?: boolean;

  /**  */
  twoFactorEnabled?: boolean;

  /**  */
  lockoutEnd?: Date;

  /**  */
  lockoutEnabled?: boolean;

  /**  */
  active?: boolean;

  /**  */
  lastLogin?: Date;

  /**  */
  accessFailedCount?: number;

  /**  */
  roles?: string[];
}

export interface AgentUserPagingResponseBasePagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: AgentUserPagingResponse[];
}

export interface AreaAggregation {
  /**  */
  key?: string;

  /**  */
  value?: string;

  /**  */
  count?: number;

  /**  */
  cities?: CityAggregation[];
}

export interface AvailableHotelAutocompletionModel {
  /**  */
  hotelCode?: string;

  /**  */
  hotelName?: string;
}

export interface AvailableHotelModel {
  /**  */
  hotelCode?: string;

  /**  */
  hotelName?: string;

  /**  */
  originalName?: string;

  /**  */
  type?: string;

  /**  */
  access?: string;

  /**  */
  prefectureName?: string;

  /**  */
  areaName?: string;

  /**  */
  cityName?: string;

  /**  */
  address?: string;

  /**  */
  starRating?: number;

  /**  */
  reviewRating?: number;

  /**  */
  location?: HotelLocation;

  /**  */
  facilities?: string[];

  /**  */
  boardTypes?: string[];

  /**  */
  hotelImages?: string[];

  /**  */
  roomTypes?: string[];

  /**  */
  cheapestPrice?: number;
}

export interface AvailableHotelPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: AvailableHotelModel[];

  /**  */
  sessionExpired?: boolean;
}

export interface AvailableRoomModel {
  /**  */
  noOfAdult?: number;

  /**  */
  noOfChild?: number;

  /**  */
  noOfRooms?: number;

  /**  */
  availableRoomTypes?: AvailableRoomType[];
}

export interface AvailableRoomPlan {
  /**  */
  planId?: string;

  /**  */
  code?: string;

  /**  */
  name?: string;

  /**  */
  planTitle?: string;

  /**  */
  planDesc?: string;

  /**  */
  boardTypeCode?: string;

  /**  */
  boardType?: string;

  /**  */
  checkinTime?: string;

  /**  */
  checkoutTime?: string;

  /**  */
  originalPrice?: number;

  /**  */
  originalCurrency?: string;

  /**  */
  price?: number;

  /**  */
  currency?: string;

  /**  */
  conversionRate?: number;

  /**  */
  priceUnits?: RoomPlanPriceUnit[];

  /**  */
  maxAdult?: number;

  /**  */
  maxChild?: number;

  /**  */
  cutoffDate?: number;

  /**  */
  cancellationPolicies?: RoomCancellationPolicy[];

  /**  */
  cancellationNotes?: string;

  /**  */
  paymentNotes?: string;

  /**  */
  nonRefundable?: boolean;

  /**  */
  includedTaxes?: boolean;

  /**  */
  includedFees?: boolean;

  /**  */
  remarks?: string;

  /**  */
  breakfastPlace?: string;

  /**  */
  breakfastName?: string;

  /**  */
  breakfastDetails?: string;

  /**  */
  dinnerPlace?: string;

  /**  */
  dinnerName?: string;

  /**  */
  dinnerDetails?: string;

  /**  */
  dinnerMainDish?: string;
}

export interface AvailableRoomType {
  /**  */
  roomTypeId?: string;

  /**  */
  name?: string;

  /**  */
  category?: string;

  /**  */
  roomTypeCode?: string;

  /**  */
  availableSlot?: number;

  /**  */
  roomInfo?: RoomTypeInfo;

  /**  */
  roomPlans?: AvailableRoomPlan[];

  /**  */
  supplier?: string;

  /**  */
  supplierHotelCode?: string;
}

export interface BaseResponseModel {
  /**  */
  success?: boolean;

  /**  */
  message?: string;
}

export interface BookingHistoryModel {
  /**  */
  id?: string;

  /**  */
  orderId?: string;

  /**  */
  refNumber?: string;

  /**  */
  agentBookingRef?: string;

  /**  */
  bookingStatus?: BookingStatus;

  /**  */
  paymentStatus?: PaymentStatus;

  /**  */
  bookingDate?: Date;

  /**  */
  checkinDate?: Date;

  /**  */
  checkoutDate?: Date;

  /**  */
  balance?: number;

  /**  */
  sellingPrice?: number;

  /**  */
  currency?: string;

  /**  */
  hotelName?: string;

  /**  */
  hotelCode?: string;
}

export interface BookingPagingRequest {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  orderBy?: string;

  /**  */
  orderByAsc?: boolean;

  /**  */
  refNumber?: string;

  /**  */
  supplierNames?: string[];

  /**  */
  hotelRoomStatuses?: HotelRoomStatus[];

  /**  */
  supplierRefNumber?: string;

  /**  */
  orderId?: string;

  /**  */
  agentCode?: string;

  /**  */
  bookingStatus?: BookingStatus[];

  /**  */
  paymentStatus?: PaymentStatus[];

  /**  */
  hotelName?: string;

  /**  */
  bookingFrom?: Date;

  /**  */
  bookingTo?: Date;

  /**  */
  cancellationFrom?: Date;

  /**  */
  cancellationTo?: Date;

  /**  */
  checkinFrom?: Date;

  /**  */
  checkinTo?: Date;

  /**  */
  checkoutFrom?: Date;

  /**  */
  checkoutTo?: Date;

  /**  */
  leadPassenger?: string;

  /**  */
  agentBookingRef?: string;

  /**  */
  isOnHold?: boolean;

  /**  */
  autoCancelTime?: AutoCancelTime;
}

export interface BookingPagingResponse {
  /**  */
  id?: string;

  /**  */
  orderId?: string;

  /**  */
  refNumber?: string;

  /**  */
  agentBookingRef?: string;

  /**  */
  bookingStatus?: BookingStatus;

  /**  */
  paymentStatus?: PaymentStatus;

  /**  */
  bookingDate?: Date;

  /**  */
  checkinDate?: Date;

  /**  */
  checkoutDate?: Date;

  /**  */
  balance?: number;

  /**  */
  sellingPrice?: number;

  /**  */
  currency?: string;

  /**  */
  leadPassenger?: string;

  /**  */
  hotelName?: string;

  /**  */
  hotelCode?: string;

  /**  */
  supplierRefNumbers?: string[];

  /**  */
  roomSuppliers?: string[];

  /**  */
  roomStatus?: HotelRoomStatus[];

  /**  */
  onHoldPaymentDeadline?: Date;
}

export interface BookingPagingResponseBasePagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: BookingPagingResponse[];
}

export interface BookingSuccessRateReportItem {
  /**  */
  firstName?: string;

  /**  */
  lastName?: string;

  /**  */
  userName?: string;

  /**  */
  bookedRate?: number;

  /**  */
  onHoldRate?: number;

  /**  */
  cancelledRate?: number;
}

export interface BookingSummaryOfTheYearReportItem {
  /**  */
  firstName?: string;

  /**  */
  lastName?: string;

  /**  */
  userName?: string;

  /**  */
  noOfJan?: number;

  /**  */
  noOfFeb?: number;

  /**  */
  noOfMar?: number;

  /**  */
  noOfApr?: number;

  /**  */
  noOfMay?: number;

  /**  */
  noOfJun?: number;

  /**  */
  noOfJul?: number;

  /**  */
  noOfAug?: number;

  /**  */
  noOfSep?: number;

  /**  */
  noOfOtc?: number;

  /**  */
  noOfNov?: number;

  /**  */
  noOfDec?: number;
}

export interface BookingSummaryReportModel {
  /**  */
  totalAutomaticCancellationWithin24Hours?: number;

  /**  */
  totalAutomaticCancellationWithin48Hours?: number;

  /**  */
  upComingBookingsWithin7Days?: number;

  /**  */
  upComingBookingsWithin30Days?: number;

  /**  */
  totalInProcessBookings?: number;

  /**  */
  currency?: string;
}

export interface CancelBookingRequest {
  /**  */
  bookingId: string;

  /**  */
  cancellationFee: number;
}

export interface CancelBookingResponse {
  /**  */
  success?: boolean;

  /**  */
  message?: string;

  /**  */
  cancellationFeeChanged?: boolean;
}

export interface CancelBookingSummaryDetail {
  /**  */
  bookingId?: string;

  /**  */
  refNumber?: string;

  /**  */
  bookingStatus?: BookingStatus;

  /**  */
  paymentStatus?: PaymentStatus;

  /**  */
  createdAt?: Date;

  /**  */
  hotelName?: string;

  /**  */
  images?: string[];

  /**  */
  paidAmount?: number;

  /**  */
  cancellationFee?: number;

  /**  */
  refundAmount?: number;

  /**  */
  currency?: string;
}

export interface CancelBookingSummaryModel {
  /**  */
  success?: boolean;

  /**  */
  message?: string;

  /**  */
  booking?: CancelBookingSummaryDetail;
}

export interface CancelOrderBookingRequest {
  /**  */
  orderId: string;

  /**  */
  bookings: CancelBookingRequest[];
}

export interface CancelOrderBookingsSummaryModel {
  /**  */
  success?: boolean;

  /**  */
  message?: string;

  /**  */
  orderId?: string;

  /**  */
  bookings?: CancelBookingSummaryDetail[];
}

export interface CancelPartialBookingResponse {
  /**  */
  success?: boolean;

  /**  */
  message?: string;

  /**  */
  cancellationFeeChanged?: boolean;

  /**  */
  paymentUnSuccess?: boolean;
}

export interface CityAggregation {
  /**  */
  key?: string;

  /**  */
  value?: string;

  /**  */
  count?: number;
}

export interface CompleteBookingRequest {
  /**  */
  sessionId: string;

  /**  */
  paymentOptionName: string;

  /**  */
  creditCardMemberId?: string;
}

export interface CompleteBookingResponse {
  /**  */
  success?: boolean;

  /**  */
  message?: string;

  /**  */
  sessionExpired?: boolean;

  /**  */
  bookingId?: string;

  /**  */
  errorType?: ErrorType;

  /**  */
  partialBooked?: boolean;

  /**  */
  paymentStatus?: PaymentStatus;
}

export interface CompleteOnHoldBookingRequest {
  /**  */
  bookingId: string;

  /**  */
  paymentOptionName: string;

  /**  */
  creditCardMemberId?: string;
}

export interface CompleteOnHoldBookingResponse {
  /**  */
  success?: boolean;

  /**  */
  message?: string;

  /**  */
  errorType?: ErrorType;

  /**  */
  paymentStatus?: PaymentStatus;
}

export interface ConfirmCancelPartialBookingRequest {
  /**  */
  bookingId: string;

  /**  */
  cancellationFee: number;
}

export interface ConfirmPartialBookingDetailModel {
  /**  */
  id?: string;

  /**  */
  refNumber?: string;

  /**  */
  sellingPrice?: number;

  /**  */
  totalCancellationFee?: number;

  /**  */
  currency?: string;

  /**  */
  hotelName?: string;

  /**  */
  checkinDate?: Date;

  /**  */
  bookingStatus?: BookingStatus;

  /**  */
  bookingDate?: Date;

  /**  */
  rooms?: PartialHotelRoomModel[];
}

export interface ConfirmPartialBookingResponse {
  /**  */
  success?: boolean;

  /**  */
  message?: string;

  /**  */
  bookingStatus?: BookingStatus;

  /**  */
  paymentStatus?: PaymentStatus;
}

export interface CountryAutocompletionModel {
  /**  */
  shortCode?: string;

  /**  */
  phoneCode?: string;

  /**  */
  name?: string;
}

export interface CountryModel {
  /**  */
  id?: string;

  /**  */
  code: string;

  /**  */
  shortCode: string;

  /**  */
  phoneCode: string;

  /**  */
  continent: Continent;

  /**  */
  name?: string;
}

export interface CountryModelBasePagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: CountryModel[];
}

export interface CreateAgentCreditCardMemberRequest {
  /**  */
  token: string;

  /**  */
  cardNo: string;
}

export interface CreateAgentUserModel {
  /**  */
  firstName: string;

  /**  */
  lastName: string;

  /**  */
  userName: string;

  /**  */
  email: string;

  /**  */
  phoneCode?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  roles: string[];
}

export interface CurrentUserModel {
  /**  */
  id?: string;

  /**  */
  username?: string;

  /**  */
  email?: string;

  /**  */
  firstName?: string;

  /**  */
  lastName?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  roles?: string[];

  /**  */
  roleClaims?: string[];
}

export interface DestinationModel {
  /**  */
  code?: string;

  /**  */
  type?: LocationType;

  /**  */
  name?: string;
}

export interface FileUploadResponse {
  /**  */
  success?: boolean;

  /**  */
  message?: string;

  /**  */
  fileId?: string;

  /**  */
  fileName?: string;
}

export interface ForgotPasswordModel {
  /**  */
  token?: string;

  /**  */
  newPassword?: string;
}

export interface GuidBaseUpdateModel {
  /**  */
  success?: boolean;

  /**  */
  message?: string;

  /**  */
  id?: string;
}

export interface HotelBathFurniture {
  /**  */
  name?: string;

  /**  */
  isFree?: boolean;
}

export interface HotelBathInfo {
  /**  */
  code?: string;

  /**  */
  name?: string;

  /**  */
  type?: string;

  /**  */
  gender?: string;

  /**  */
  allTimeAvailable?: boolean;

  /**  */
  usingTime?: string;

  /**  */
  capacity?: number;

  /**  */
  hasSpa?: boolean;

  /**  */
  hasSauna?: boolean;

  /**  */
  hasJacuzzi?: boolean;

  /**  */
  furniture?: HotelBathFurniture[];
}

export interface HotelBookmarkModel {
  /**  */
  createdAt?: Date;

  /**  */
  hotelCode?: string;

  /**  */
  hotelName?: string;

  /**  */
  hotelNameJp?: string;

  /**  */
  address?: string;

  /**  */
  starRating?: number;

  /**  */
  images?: string[];
}

export interface HotelBookmarkModelBasePagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: HotelBookmarkModel[];
}

export interface HotelBuildingInfo {
  /**  */
  buildingName?: string;

  /**  */
  buildingNameEn?: string;

  /**  */
  noOfFloors?: number;

  /**  */
  dateOfBuilding?: Date;

  /**  */
  dateOfRenovation?: Date;

  /**  */
  capacity?: number;

  /**  */
  noOfRooms?: number;

  /**  */
  bfBuildingEntrance?: boolean;

  /**  */
  bfCorridor?: boolean;

  /**  */
  bfWheelChairElevator?: boolean;

  /**  */
  bfHandrailElevator?: boolean;

  /**  */
  bfWheelChairControllerElevator?: boolean;

  /**  */
  bfToilet?: boolean;

  /**  */
  bfWheelChairToilet?: boolean;

  /**  */
  nonSmokingRoom?: boolean;
}

export interface HotelFilter {
  /**  */
  starRatings?: object;

  /**  */
  train5Minutes?: number;

  /**  */
  train10Minutes?: number;

  /**  */
  hotelTypes?: object;

  /**  */
  roomTypes?: object;

  /**  */
  boardTypes?: object;

  /**  */
  facilities?: object;

  /**  */
  minPrice?: number;

  /**  */
  maxPrice?: number;

  /**  */
  areas?: AreaAggregation[];

  /**  */
  cities?: CityAggregation[];
}

export interface HotelInfoImage {
  /**  */
  isMain?: boolean;

  /**  */
  url?: string;

  /**  */
  alt?: string;
}

export interface HotelInfoModel {
  /**  */
  code?: string;

  /**  */
  name?: string;

  /**  */
  nameEn?: string;

  /**  */
  type?: string;

  /**  */
  prefectureCode?: string;

  /**  */
  prefectureName?: string;

  /**  */
  areaCode?: string;

  /**  */
  areaName?: string;

  /**  */
  cityCode?: string;

  /**  */
  cityName?: string;

  /**  */
  postalCode?: string;

  /**  */
  address?: string;

  /**  */
  starRating?: number;

  /**  */
  reviewRating?: number;

  /**  */
  latitude?: number;

  /**  */
  longitude?: number;

  /**  */
  phoneNumber?: string;

  /**  */
  faxNumber?: string;

  /**  */
  email?: string;

  /**  */
  url?: string;

  /**  */
  description?: string;

  /**  */
  specialNotes?: string;

  /**  */
  train5Minutes?: boolean;

  /**  */
  train10Minutes?: boolean;

  /**  */
  capacity?: number;

  /**  */
  noOfRooms?: number;

  /**  */
  roomDetail?: string;

  /**  */
  checkinTime?: string;

  /**  */
  checkoutTime?: string;

  /**  */
  transferCategory?: string;

  /**  */
  hasParkingLot?: boolean;

  /**  */
  noOfParkingLot?: number;

  /**  */
  parkingFee?: number;

  /**  */
  parkingFeeUnit?: string;

  /**  */
  parkingHeightRestriction?: boolean;

  /**  */
  hasBabyBed?: boolean;

  /**  */
  freeBabyBed?: boolean;

  /**  */
  babyBedFee?: number;

  /**  */
  hasChildMeal?: boolean;

  /**  */
  freeChildMeal?: boolean;

  /**  */
  childMealFee?: number;

  /**  */
  hasBabyStrollers?: boolean;

  /**  */
  freeBabyStrollers?: boolean;

  /**  */
  babyStrollersFee?: number;

  /**  */
  englishCommunication?: boolean;

  /**  */
  chineseCommunication?: boolean;

  /**  */
  koreanCommunication?: boolean;

  /**  */
  otherName?: string;

  /**  */
  access?: string;

  /**  */
  hasBath?: boolean;

  /**  */
  hasPool?: boolean;

  /**  */
  furniture?: string[];

  /**  */
  hotelBuildings?: HotelBuildingInfo[];

  /**  */
  hotelBaths?: HotelBathInfo[];

  /**  */
  hotelPools?: HotelPoolInfo[];

  /**  */
  hotelVicinities?: string[];

  /**  */
  images?: HotelInfoImage[];
}

export interface HotelLocation {
  /**  */
  lat?: number;

  /**  */
  lon?: number;
}

export interface HotelPoolInfo {
  /**  */
  name?: string;

  /**  */
  isIndoor?: boolean;

  /**  */
  isOutdoor?: boolean;

  /**  */
  heatedWater?: boolean;

  /**  */
  coldWater?: boolean;

  /**  */
  width?: number;

  /**  */
  length?: number;

  /**  */
  depth?: number;

  /**  */
  fee?: number;

  /**  */
  towelLending?: boolean;

  /**  */
  openFromMonth?: number;

  /**  */
  openToMonth?: number;

  /**  */
  openingTime?: string;

  /**  */
  closingTime?: string;

  /**  */
  hasChildPool?: boolean;
}

export interface HotelQueryModel {
  /**  */
  locationCode?: string;

  /**  */
  locationType?: LocationType;

  /**  */
  checkinDate?: Date;

  /**  */
  checkoutDate?: Date;

  /**  */
  rooms?: RoomSearchInfo[];

  /**  */
  currency?: string;

  /**  */
  createdAt?: Date;

  /**  */
  boardType?: BoardType;
}

export interface HotelRoomImage {
  /**  */
  url?: string;

  /**  */
  alt?: string;
}

export interface HotelRoomResponse {
  /**  */
  success?: boolean;

  /**  */
  message?: string;

  /**  */
  sessionId?: string;

  /**  */
  availableRooms?: AvailableRoomModel[];
}

export interface HotelSearchRequest {
  /**  */
  locationCode: string;

  /**  */
  locationType: LocationType;

  /**  */
  checkinDate: Date;

  /**  */
  checkoutDate: Date;

  /**  */
  rooms: RoomSearchInfo[];

  /**  */
  boardType: BoardType;

  /**  */
  sessionId?: string;

  /**  */
  currency?: string;
}

export interface HotelSearchResponse {
  /**  */
  success?: boolean;

  /**  */
  message?: string;

  /**  */
  sessionId?: string;

  /**  */
  ntaHotelAvailable?: boolean;

  /**  */
  allSuppliers?: boolean;

  /**  */
  ttl?: number;

  /**  */
  hotelQuery?: HotelQueryModel;
}

export interface LandingDestinationModel {
  /**  */
  code?: string;

  /**  */
  name?: string;

  /**  */
  hotelAddress?: string;

  /**  */
  type?: LocationType;

  /**  */
  countryCode?: string;

  /**  */
  countryName?: string;
}

export interface LandingSliderImageModel {
  /**  */
  fileId?: string;

  /**  */
  hyperlink?: string;

  /**  */
  order?: number;
}

export interface LoginModel {
  /**  */
  userName: string;

  /**  */
  password: string;
}

export interface LoginResponseModel {
  /**  */
  success?: boolean;

  /**  */
  message?: string;

  /**  */
  accessToken?: string;

  /**  */
  refreshToken?: string;

  /**  */
  isPasswordExpired?: boolean;

  /**  */
  accessFailedCount?: number;

  /**  */
  lockoutEnd?: Date;

  /**  */
  currentUser?: CurrentUserModel;
}

export interface OnHoldBookingResponse {
  /**  */
  success?: boolean;

  /**  */
  message?: string;

  /**  */
  sessionExpired?: boolean;

  /**  */
  bookingId?: string;

  /**  */
  errorType?: ErrorType;

  /**  */
  partialBooked?: boolean;
}

export interface OrderBookingDetailModel {
  /**  */
  id?: string;

  /**  */
  refNumber?: string;

  /**  */
  agentBookingRef?: string;

  /**  */
  bookingStatus?: BookingStatus;

  /**  */
  paymentStatus?: PaymentStatus;

  /**  */
  bookingDate?: Date;

  /**  */
  checkinDate?: Date;

  /**  */
  checkoutDate?: Date;

  /**  */
  adultCount?: number;

  /**  */
  childCount?: number;

  /**  */
  sellingPrice?: number;

  /**  */
  currency?: string;

  /**  */
  leadPassenger?: string;

  /**  */
  hotelName?: string;

  /**  */
  hotelAddress?: string;

  /**  */
  hotelImages?: string[];

  /**  */
  supplierRefNumbers?: string[];

  /**  */
  roomSuppliers?: string[];

  /**  */
  roomStatus?: HotelRoomStatus[];

  /**  */
  onHoldPaymentDeadline?: Date;
}

export interface PartialHotelRoomModel {
  /**  */
  id?: string;

  /**  */
  noOfAdult?: number;

  /**  */
  noOfChild?: number;

  /**  */
  supplier?: string;

  /**  */
  supplierHotelCode?: string;

  /**  */
  roomTypeName?: string;

  /**  */
  roomTypeCategory?: string;

  /**  */
  noOfRooms?: number;

  /**  */
  price?: number;

  /**  */
  status?: HotelRoomStatus;

  /**  */
  nonRefundable?: boolean;

  /**  */
  cancellationPolicies?: RoomCancellationPolicy[];
}

export interface PaymentOptionModel {
  /**  */
  name?: string;

  /**  */
  displayName?: string;

  /**  */
  creditCardRequired?: boolean;
}

export interface PopularHotelModel {
  /**  */
  hotelCode?: string;

  /**  */
  order?: number;

  /**  */
  hotelName?: string;

  /**  */
  hotelNameJp?: string;

  /**  */
  address?: string;

  /**  */
  starRating?: number;

  /**  */
  cheapestPrice?: number;

  /**  */
  images?: string[];
}

export interface PreBookContactDetailRequest {
  /**  */
  firstName?: string;

  /**  */
  lastName?: string;

  /**  */
  email?: string;

  /**  */
  phoneCode?: string;

  /**  */
  phoneNumber?: string;
}

export interface PreBookHotelRequest {
  /**  */
  sessionId?: string;

  /**  */
  hotelCode?: string;

  /**  */
  bookingRefNumber?: string;

  /**  */
  rooms?: PreBookRoomRequest[];
}

export interface PreBookHotelResponseModel {
  /**  */
  success?: boolean;

  /**  */
  message?: string;

  /**  */
  sessionExpired?: boolean;

  /**  */
  sessionId?: string;
}

export interface PreBookPassengerGenderModel {
  /**  */
  roomIndex?: number;

  /**  */
  maleCount?: number;
}

export interface PreBookRoomRequest {
  /**  */
  noOfAdult?: number;

  /**  */
  noOfChild?: number;

  /**  */
  roomPlanId?: string;

  /**  */
  noOfRooms?: number;
}

export interface PrebookContactDetailModel {
  /**  */
  firstName?: string;

  /**  */
  lastName?: string;

  /**  */
  email?: string;

  /**  */
  phoneCode?: string;

  /**  */
  phoneNumber?: string;
}

export interface PrebookHotelConfirmationModel {
  /**  */
  sessionId?: string;

  /**  */
  sessionExpired?: boolean;

  /**  */
  locationCode?: string;

  /**  */
  locationType?: LocationType;

  /**  */
  checkinDate?: Date;

  /**  */
  checkoutDate?: Date;

  /**  */
  rooms?: RoomSearchInfo[];

  /**  */
  currency?: string;

  /**  */
  selectedHotel?: SelectedHotelModel;

  /**  */
  boardType?: BoardType;

  /**  */
  ttl?: number;
}

export interface PrebookHotelSummaryModel {
  /**  */
  sessionId?: string;

  /**  */
  sessionExpired?: boolean;

  /**  */
  locationCode?: string;

  /**  */
  locationType?: LocationType;

  /**  */
  checkinDate?: Date;

  /**  */
  checkoutDate?: Date;

  /**  */
  rooms?: RoomSearchInfo[];

  /**  */
  currency?: string;

  /**  */
  selectedHotel?: SelectedHotelModel;

  /**  */
  boardType?: BoardType;

  /**  */
  ttl?: number;

  /**  */
  agentBookingRef?: string;

  /**  */
  contactDetail?: PrebookContactDetailModel;

  /**  */
  leadPassenger?: PrebookLeadPaxModel;

  /**  */
  passengerGenders?: PreBookPassengerGenderModel[];

  /**  */
  onHoldAllowance?: boolean;

  /**  */
  paymentOptions?: PaymentOptionModel[];
}

export interface PrebookLeadPaxModel {
  /**  */
  firstName?: string;

  /**  */
  lastName?: string;

  /**  */
  emailAddress?: string;

  /**  */
  countryCode?: string;

  /**  */
  countryName?: string;

  /**  */
  phoneCode?: string;

  /**  */
  phoneNumber?: string;
}

export interface PrebookLeadPaxRequest {
  /**  */
  firstName?: string;

  /**  */
  lastName?: string;

  /**  */
  emailAddress?: string;

  /**  */
  countryCode?: string;

  /**  */
  phoneCode?: string;

  /**  */
  phoneNumber?: string;
}

export interface RefreshTokenRequest {
  /**  */
  userId?: string;

  /**  */
  accessToken?: string;

  /**  */
  refreshToken?: string;
}

export interface RefreshTokenResponse {
  /**  */
  success?: boolean;

  /**  */
  message?: string;

  /**  */
  userId?: string;

  /**  */
  accessToken?: string;

  /**  */
  refreshToken?: string;
}

export interface RegisterAgentModel {
  /**  */
  companyName: string;

  /**  */
  agentType?: AgentType;

  /**  */
  iataId?: string;

  /**  */
  countryCode: string;

  /**  */
  cityName: string;

  /**  */
  companyPhoneNumber: string;

  /**  */
  companyAddress: string;

  /**  */
  companyPostalCode: string;

  /**  */
  companyEmailAddress: string;

  /**  */
  companySize?: AgentCompanySize;

  /**  */
  companyWebsite: string;

  /**  */
  picFirstName: string;

  /**  */
  picLastName: string;

  /**  */
  picEmail: string;

  /**  */
  ecFirstName?: string;

  /**  */
  ecLastName?: string;

  /**  */
  ecPhoneNumber?: string;

  /**  */
  ecEmail?: string;

  /**  */
  accountantFirstName?: string;

  /**  */
  accountantLastName?: string;

  /**  */
  accountantPhoneNumber?: string;

  /**  */
  accountantEmail?: string;

  /**  */
  licenseFileIds?: string[];

  /**  */
  paymentOptions?: string[];

  /**  */
  userName: string;
}

export interface RoomCancellationPolicy {
  /**  */
  dayPeriod?: number;

  /**  */
  bufferDays?: number;

  /**  */
  isPercentage?: boolean;

  /**  */
  value?: number;

  /**  */
  originalValue?: number;

  /**  */
  originalCurrency?: string;
}

export interface RoomPlanPriceUnit {
  /**  */
  date?: Date;

  /**  */
  originalPrice?: number;

  /**  */
  originalAdultPrice?: number;

  /**  */
  originalChildPrice?: number;

  /**  */
  price?: number;
}

export interface RoomSearchInfo {
  /**  */
  roomIndex: number;

  /**  */
  noOfAdult: number;

  /**  */
  noOfChild: number;

  /**  */
  childAges?: number[];
}

export interface RoomTypeInfo {
  /**  */
  buildingName?: string;

  /**  */
  roomTypeView?: string;

  /**  */
  maxGuest?: number;

  /**  */
  minGuest?: number;

  /**  */
  hasBath?: boolean;

  /**  */
  hasToilet?: boolean;

  /**  */
  basicSize?: string;

  /**  */
  basicUnit?: string;

  /**  */
  noOfBeds?: number;

  /**  */
  bedName?: string;

  /**  */
  bedWidth?: number;

  /**  */
  bedLength?: number;

  /**  */
  noOfExtraBeds?: number;

  /**  */
  extraBedWidth?: number;

  /**  */
  extraBedLength?: number;

  /**  */
  airConditioner?: boolean;

  /**  */
  toiletShower?: boolean;

  /**  */
  standWashing?: boolean;

  /**  */
  openAirBath?: boolean;

  /**  */
  showerBooth?: boolean;

  /**  */
  spaBath?: boolean;

  /**  */
  jacuzzi?: boolean;

  /**  */
  internetAvailable?: boolean;

  /**  */
  internetFee?: boolean;

  /**  */
  washingArea?: boolean;

  /**  */
  smokingRoom?: boolean;

  /**  */
  images?: HotelRoomImage[];
}

export interface SaleByUserReportItem {
  /**  */
  firstName?: string;

  /**  */
  lastName?: string;

  /**  */
  userName?: string;

  /**  */
  noOfBookings?: number;
}

export interface SaleByUserReportModel {
  /**  */
  items?: SaleByUserReportItem[];

  /**  */
  totalBookings?: number;
}

export interface SearchHotelRoomsRequest {
  /**  */
  hotelCode?: string;

  /**  */
  checkinDate?: Date;

  /**  */
  checkoutDate?: Date;

  /**  */
  rooms?: RoomSearchInfo[];

  /**  */
  sessionId?: string;

  /**  */
  currency?: string;
}

export interface SelectedHotelModel {
  /**  */
  hotelCode?: string;

  /**  */
  hotelName?: string;

  /**  */
  hotelNameJp?: string;

  /**  */
  access?: string;

  /**  */
  postalCode?: string;

  /**  */
  address?: string;

  /**  */
  addressJp?: string;

  /**  */
  description?: string;

  /**  */
  starRating?: number;

  /**  */
  reviewRating?: number;

  /**  */
  tel?: string;

  /**  */
  fax?: string;

  /**  */
  checkinTime?: string;

  /**  */
  checkoutTime?: string;

  /**  */
  totalPrice?: number;

  /**  */
  totalPriceChanged?: number;

  /**  */
  images?: string[];

  /**  */
  rooms?: SelectedRoomModel[];
}

export interface SelectedRoomModel {
  /**  */
  noOfAdult?: number;

  /**  */
  noOfChild?: number;

  /**  */
  supplierHotelCode?: string;

  /**  */
  roomTypeCode?: string;

  /**  */
  roomTypeName?: string;

  /**  */
  roomTypeCategory?: string;

  /**  */
  supplier?: string;

  /**  */
  checkinTime?: string;

  /**  */
  checkoutTime?: string;

  /**  */
  planId?: string;

  /**  */
  planCode?: string;

  /**  */
  planName?: string;

  /**  */
  planTitle?: string;

  /**  */
  planDesc?: string;

  /**  */
  boardTypeCode?: string;

  /**  */
  boardType?: string;

  /**  */
  originalPrice?: number;

  /**  */
  originalPriceChanged?: number;

  /**  */
  originalCurrency?: string;

  /**  */
  price?: number;

  /**  */
  priceChanged?: number;

  /**  */
  conversionRate?: number;

  /**  */
  currency?: string;

  /**  */
  priceUnits?: RoomPlanPriceUnit[];

  /**  */
  cancellationPolicies?: RoomCancellationPolicy[];

  /**  */
  images?: string[];

  /**  */
  cancellationNotes?: string;

  /**  */
  paymentNotes?: string;

  /**  */
  nonRefundable?: boolean;

  /**  */
  includedTaxes?: boolean;

  /**  */
  includedFees?: boolean;

  /**  */
  noOfRooms?: number;

  /**  */
  remarks?: string;

  /**  */
  breakfastPlace?: string;

  /**  */
  breakfastName?: string;

  /**  */
  breakfastDetails?: string;

  /**  */
  dinnerPlace?: string;

  /**  */
  dinnerName?: string;

  /**  */
  dinnerDetails?: string;

  /**  */
  smokingRoom?: boolean;
}

export interface SetPreBookPaxInfoRequest {
  /**  */
  sessionId?: string;

  /**  */
  agentBookingRef?: string;

  /**  */
  contactDetail?: PreBookContactDetailRequest;

  /**  */
  passengerGenders?: PreBookPassengerGenderModel[];

  /**  */
  leadPassenger?: PrebookLeadPaxRequest;

  /**  */
  nonSmokingRoom?: boolean;

  /**  */
  honeymooners?: boolean;

  /**  */
  roomsCloseToEachOther?: boolean;
}

export interface SetPrebookPaxInfoResponse {
  /**  */
  success?: boolean;

  /**  */
  message?: string;

  /**  */
  sessionExpired?: boolean;
}

export interface UpdateAgentBookingRefModel {
  /**  */
  bookingId?: string;

  /**  */
  agentBookingRef?: string;
}

export interface UpdateAgentCreditCardMemberRequest {
  /**  */
  id: string;

  /**  */
  token: string;

  /**  */
  cardNo: string;
}

export interface UpdateAgentUserModel {
  /**  */
  id?: string;

  /**  */
  firstName: string;

  /**  */
  lastName: string;

  /**  */
  email: string;

  /**  */
  phoneCode?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  active: boolean;

  /**  */
  roles: string[];
}

export interface UpdateAgentUserProfileModel {
  /**  */
  firstName: string;

  /**  */
  lastName: string;

  /**  */
  phoneCode?: string;

  /**  */
  phoneNumber?: string;
}

export type AgentCompanySize = 1 | 2 | 3;

export type AgentStatus = 0 | 1 | 2 | 3;

export type AgentType = 1 | 2 | 3 | 4 | 5;

export type AutoCancelTime = 24 | 48;

export type BoardType = 1 | 3 | 4 | 5;

export type BookingStatus = 1 | 2 | 3 | 4 | 5 | 6 | 7;

export type Continent = 1 | 2 | 3 | 4 | 5 | 6 | 7;

export type ErrorType = 0 | 1 | 2 | 3 | 4 | 5;

export type HotelRoomStatus = 1 | 2 | 3 | 4;

export type LocationType = 1 | 2 | 3 | 4 | 5;

export type OrderStatus = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;

export type PaymentStatus = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
